import BaseService from "./BaseService";

const API_APPLICATIONS_BY_CATEGORY = `${process.env.VUE_APP_BACKEND_API}/Applications/ByCategory`;
const API_APPLICATIONS = `${process.env.VUE_APP_BACKEND_API}/Applications`;
const API_APP_PREFERENCE = `${process.env.VUE_APP_BACKEND_API}/Applications/UserPreference`;

class ApplicationService extends BaseService {
    /**
     * Get all applications by category.
     *
     * @return {Promise}
     */
    static getApplicationsByCategory() {
        if (!this.hasSession())
            return Promise.reject();

        return window.axios.get(API_APPLICATIONS_BY_CATEGORY);
    }

    /**
     * Search for applications.
     *
     * @param {String} query
     *
     * @return {Promise}
     */
    static searchApplications(query = "") {
        if (!this.hasSession())
            return Promise.reject();

        let url = `${API_APPLICATIONS}?name=${encodeURIComponent(query)}`;
        return window.axios.get(url);
    }

    /**
     * Get the recent and the most viewed apps.
     *
     * @return {Promise}
     */
    static getRecentAndMostViewedApplications() {
        if (!this.hasSession())
            return Promise.reject();

        let url = `${API_APPLICATIONS}/Preferences`;
        return window.axios.get(url);
    }

    /**
     * Pin a specific application to a category.
     *
     * @param {Int} appId
     * @param {Int} categoryId
     *
     * @return {Promise}
     */
    static pinApplication(appId, categoryId) {
        if (!this.hasSession())
            return Promise.reject();

        let url = `${API_APPLICATIONS}/${appId}/Category/${categoryId}/Pin`;

        return window.axios.post(url);
    }

    /**
     * Favorite an application.
     *
     * @param {Int} appId
     * @param {Boolean} state
     *
     * @return {Promise}
     */
    static favoriteApplication(appId, state = true) {
        if (!this.hasSession())
            return Promise.reject();

        let body = {"state": state};
        let url = `${API_APPLICATIONS}/${appId}/Favorite`;

        return window.axios.post(url, body);
    }

    /**
     * Visit an application and send data to generate most viewed and recent apps.
     *
     * @param {Int} appId
     * @param {string} appName
     *
     * @return {Promise}
     */
    static goToApplication(appId) {
        if (!this.hasSession())
            return Promise.reject();

        let url = `${API_APP_PREFERENCE}/Add(${appId})`;
        window.axios.post(url).then(() => {
            this.getRecentAndMostViewedApplications()
                .then(response => {
                    localStorage.setItem('UserPreferences', JSON.stringify(response.data));
                }).catch(error => console.log(error));
        });
    }
}

export default ApplicationService;
